export var testConfig = {
    authApiUrl: 'https://test.auth.move.tomtom.com',
    legolandApiUrl: 'https://test.api.move.tomtom.com',
    legolandUiUrl: 'https://test.move.tomtom.com',
};
//# sourceMappingURL=testConfig.js.map